import React from 'react';
import './SubNav.css';

const SubNav = () => {

  // Function to handle smooth scrolling
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // 'block: start' aligns the top of the section to the top of the screen
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="sub-nav">
      <div className="container sub-nav-flex">
        
        {/* Click Handler for Coverage */}
        <div 
            className="sub-item" 
            onClick={() => scrollToSection('integrated-coverage')}
        >
            Integrated supply chain coverage
        </div>

        {/* Click Handler for Commodities */}
        <div 
            className="sub-item" 
            onClick={() => scrollToSection('commodities-section')}
        >
            Commodities we cover
        </div>

        {/* Click Handler for Advantage */}
        <div 
            className="sub-item" 
            onClick={() => scrollToSection('provenance-advantage')}
        >
            The Provenance advantage
        </div>

      </div>
    </div>
  );
};

export default SubNav;